var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolunteerround(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FF7000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2144 30.464C27.0051 30.464 24.4286 27.8876 24.4286 24.6783C24.4286 21.5142 27.0051 18.8926 30.2144 18.8926C33.3784 18.8926 36.0001 21.5142 36.0001 24.6783C36.0001 27.8876 33.3784 30.464 30.2144 30.464ZM34.5084 31.9556C37.7629 32.0912 40.3394 34.7581 40.3394 38.0126V39.8658C40.3394 41.0862 39.3449 42.0354 38.1697 42.0354H22.259C21.0386 42.0354 20.0894 41.0862 20.0894 39.8658V38.0126C20.0894 34.7581 22.6206 32.0912 25.8751 31.9556L28.0447 40.589L29.4911 34.4417L28.0447 31.9104H32.384L30.9376 34.4417L32.384 40.589L34.5084 31.9556Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteerround);
export default __webpack_public_path__ + "static/media/volunteerround.5933f9fc5ea423f338cb56e0846c11db.svg";
export { ForwardRef as ReactComponent };